/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../css/login.css';
import {connect} from 'react-redux';
import {backToLogin, submitInitChallenge} from '../actions/actions';
import {Link} from 'react-router-dom';
import PropTypes from "prop-types";
import stringifyQuery from 'query-string-for-all'
import {BASE_PATH} from '../utils/APIUtility';

class BackToLoginLink extends React.Component {
    render() {
      const authEndpoint = process.env.REACT_APP_AUTHORIZE_ENDPOINT;
      const {onClick, responseType, clientId, redirectURI, state, codeChallenge, codeChallengeMethod, prompt} = this.props;
      const query = stringifyQuery.stringify({client_id: clientId, response_type: responseType, redirect_uri: redirectURI, state: state,
        code_challenge: codeChallenge, code_challenge_method: codeChallengeMethod, prompt: prompt});
      return (
          <div className="back-to-login">
              <Link to={BASE_PATH + authEndpoint + "?" + query}
                    onClick={() => onClick(responseType, clientId, redirectURI, state, null, codeChallenge, codeChallengeMethod, prompt)}>
                  Back To Login
              </Link>
          </div>
      );
    }
}

BackToLoginLink.propTypes = {
  responseType: PropTypes.string,
  clientId: PropTypes.string,
  redirectURI: PropTypes.string,
  state: PropTypes.string,
  redirect: PropTypes.string,
  codeChallenge: PropTypes.string,
  codeChallengeMethod: PropTypes.string,
  prompt: PropTypes.string
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (responseType, clientId, redirectURI, state, redirect, codeChallenge, codeChallengeMethod, prompt) => {
      dispatch(backToLogin());
      dispatch(submitInitChallenge(responseType, clientId, redirectURI, state, redirect, null, null, null, codeChallenge, codeChallengeMethod, prompt));
    }
  }
};

const mapStateToProps = (state) => {
  return {
    responseType: state.login.responseType,
    clientId: state.login.clientId,
    redirectURI: state.login.redirectURI,
    state: state.login.state,
    redirect: state.login.redirect,
    codeChallenge: state.login.codeChallenge,
    codeChallengeMethod: state.login.codeChallengeMethod,
    prompt: state.login.prompt
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackToLoginLink);
